import { render } from "./MessageToast.vue?vue&type=template&id=42e704e2"
import script from "./MessageToast.vue?vue&type=script&lang=ts"
export * from "./MessageToast.vue?vue&type=script&lang=ts"
script.render = render

export default script